import styled from 'styled-components/macro';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONT_FAMILY, FONTS } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { Images } from 'assets/images';

export const SettingsWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
  background-image: url(${Images.settingsBackgroundOrigin});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 50px;
  padding-top: 100px;
  padding-bottom: 100px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const ButtonFormContainer = styled.div``;

export const MainSettingsContainer = styled.div`
  width: 1204px;
  ${FLEX_CONTAINER.FlexCenterRow};
  align-items: unset;
  background: ${COLORS.white};
  box-shadow: 0px 2px 16px ${COLORS.mainColor};
  border-radius: 12px;

  @media only screen and ${deviceMax.desktop} {
    width: 948px;
    box-shadow: unset;
  }

  @media only screen and ${deviceMax.laptopLMax} {
    flex-wrap: wrap;
    width: 100%;
    border-radius: unset;
  }
`;

export const BackToPrevPageBlock = styled.div`
  display: none;
  width: 100%;
  padding: 35px 20px 0;
  background: ${COLORS.white};
  position: relative;
  cursor: pointer;

  @media only screen and ${deviceMax.laptopLMax} {
    display: block;
    bottom: 3px;
  }
`;

export const SettingsRightSection = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: 100%;
  border-radius: 0px 50px 50px 0px;

  @media only screen and ${deviceMax.laptopLMax} {
    border-radius: unset;
  }
`;

export const IconToPrevPage = styled.img``;

export const CategoryName = styled.div`
  width: 100%;
  color: ${COLORS.black};
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font20};
  text-align: center;
  color: ${COLORS.mainColor};
  border-bottom: 1px solid ${COLORS.lightGray};
  padding: 15px;

  @media only screen and ${deviceMax.laptopLMax} {
    display: none;
  }
`;

export const EditUserInfo = styled.div`
  width: 100%;
  padding: 20px 80px 100px 80px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding: 20px 80px 150px 80px;
    ${FLEX_CONTAINER.FlexCenterRow};
  }

  @media only screen and ${deviceMax.mobileL} {
    padding: 10px;
  }
`;

export const SettingsContainer = styled.form`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  align-items: unset;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  padding-bottom: 50px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding-bottom: unset;
    ${FLEX_CONTAINER.FlexCenterRow};
    width: 600px;
  }
`;

export const SampleContainer = styled.div``;

export const InputBlock = styled.div`
  position: relative;
  margin-top: 40px;
  width: 250px;

  @media only screen and ${deviceMax.newTabletS} {
    order: 1;
  }
`;

export const StyledErrorContent = styled.div`
  ${FONTS.font12}
  color: ${COLORS.red};
  position: absolute;
`;

export const SelectOption = styled.div`
  position: relative;
  margin-top: 40px;
  width: 250px;
  cursor: pointer;
  border-bottom: 1px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.newTabletS} {
    order: 3;
  }
`;

export const SelectBlock = styled.select`
  position: relative;
  color: ${({ defaultColor }) =>
    defaultColor ? `${COLORS.mainColor}` : `${COLORS.mainColor_op7}`};
  width: 100%;
  padding-top: 7px;
  padding-bottom: 8px;
  height: 35px;
  ${FLEX_CONTAINER.Unset};
  -webkit-appearance: none;
  font-weight: ${({ defaultColor }) => (defaultColor ? 'unset' : 300)};
  ${FONTS.font16};
  line-height: 18px;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  background-color: transparent;
  cursor: pointer;

  &.active {
    color: ${COLORS.red};
  }

  @media only screen and ${deviceMax.newTabletS} {
    order: 4;
  }
`;

export const StyledButton = styled.div`
  ${FONTS.font16};
  width: 100%;
  padding-top: 10px;
  height: 36px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontLight}
`;

export const PasswordVisibleIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 12px;
  width: 26px;
  cursor: pointer;
  z-index: 0;

  @media only screen and ${deviceMax.desktop} {
    width: 20px;
    right: 0px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 16px;
  }
`;

export const StyledInputData = styled(DatePicker)`
  ${FONTS.font16}
  width: 100%;
  height: 36px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};

  &::placeholder {
    font-family: Roboto, serif !important;
    font-weight: 300 !important;
    font-style: normal !important;
  }

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &::-webkit-calendar-picker-indicator {
    -webkit-appearance: none;
    position: absolute;
    width: 100%;
    opacity: 0;
    height: 10px;
  }

  &::placeholder {
    ${FONTS.font16}
    ${FLEX_CONTAINER.FlexRow};
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor_op7)};
    ${FONT_FAMILY.FontLight};
  }
`;

export const SelectYear = styled.select`
  padding-right: 30px;
`;

export const SelectMonth = styled.select``;

export const ErrorWrapper = styled.div`
  position: absolute;
`;

export const DatePickerBlock = styled.div`
  margin: 10px;
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  align-items: unset;
`;

export const StyledInput = styled.input`
  ${FONTS.font16}
  width: 100%;
  height: 36px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &::-webkit-calendar-picker-indicator {
    -webkit-appearance: none;
    position: absolute;
    width: 100%;
    opacity: 0;
    height: 10px;
  }

  &::placeholder {
    ${FONTS.font16}
    ${FLEX_CONTAINER.FlexRow};
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
    ${FONT_FAMILY.FontLight}
  }

  @media only screen and ${deviceMax.mobileL} {
    &::placeholder {
      ${FONTS.font12}
    }
  }
`;

export const GenderPickBlock = styled.div`
  width: 250px;
  margin-top: 30px;
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn};
  align-items: unset;

  @media only screen and ${deviceMax.newTabletS} {
    order: 5;
  }
`;

export const GenderText = styled.span`
  ${FONT_FAMILY.FontRegular}
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  margin-bottom: 4px;
`;

export const GenderSuggestions = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  width: 100%;
`;

export const RadioCheckbox = styled.input`
  margin-right: 10px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  -webkit-appearance: none;
  border-radius: 50px;
  border: ${({ error }) =>
    error ? `1px solid ${COLORS.red}` : `1px solid ${COLORS.mainColor}`};

  &:checked {
    -webkit-appearance: checkbox;
  }
`;

export const CheckboxText = styled.label`
  ${FONT_FAMILY.FontRegular}
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  text-transform: capitalize;
  cursor: pointer;

  &.active {
    color: ${COLORS.red};
  }
`;

export const BackSubmitBlock = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  gap: 20px;
  width: 100%;
  margin-top: 62px;

  @media only screen and ${deviceMax.tablet} {
    flex-direction: column-reverse;
    padding-bottom: 100px;
  }

  @media only screen and ${deviceMax.newTabletS} {
    order: 6;
  }
`;

export const FormButton = styled.button`
  width: 180px;
  height: 40px;
  background: none;
  border: 2px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};
  ${FONTS.font16}
  border-radius: 10px;
`;

export const FormButtonActive = styled.button`
  width: 180px;
  height: 40px;
  background: ${COLORS.mainColor};
  border: none;
  color: ${COLORS.white};
  ${FONTS.font16}
  border-radius: 10px;

  &:hover {
    background: ${COLORS.mainColor_op7};
  }
`;

export const StyledOption = styled.option`
  color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
`;

export const StyledDefaultOption = styled.option`
  color: ${COLORS.mainColor_op7};
`;

export const StyledErrorMessage = styled.div`
  ${FONTS.font12}
  color: ${COLORS.red};
  position: absolute;
  top: 35px;
`;
